import { render, staticRenderFns } from "./devicm.vue?vue&type=template&id=4b46111f&scoped=true&"
import script from "./devicm.vue?vue&type=script&lang=js&"
export * from "./devicm.vue?vue&type=script&lang=js&"
import style0 from "./devicm.vue?vue&type=style&index=0&id=4b46111f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46111f",
  null
  
)

export default component.exports